module.exports = __webpack_public_path__ + "static/media/tbsx3-4.62c250aa.png";